import { cn } from '@/lib/utils';
import { Spinner } from './Spinner';

interface PageLoadingProps {
  /** Additional CSS classes on the wrapper div. */
  className?: string;
}

/**
 * Full-page centered spinner used as the initial loading state for pages.
 *
 * Replaces the repeated pattern:
 * ```tsx
 * <div className="flex h-full items-center justify-center">
 *   <Spinner size="lg" />
 * </div>
 * ```
 */
export function PageLoading({ className }: Readonly<PageLoadingProps>) {
  return (
    <div className={cn('flex h-full items-center justify-center', className)}>
      <Spinner size="lg" />
    </div>
  );
}
